import React, { ReactElement, useEffect } from 'react'

import useFieldState from '../../../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import useOrderEntry from '../../../../../../useOrderEntry'

type TOtherFieldManipulator<T> = { name: string; value: T }

const OtherFieldManipulator = <T,>(
  props: TOtherFieldManipulator<T>,
): ReactElement => {
  const { name, value } = props

  const { preset } = useOrderEntry()

  const [, setDriverinstructions] = useFieldState(
    `${preset.isPickup ? 'pickup' : 'delivery'}.address.driverInstructions`,
    { ignorePrefix: true },
  )

  useEffect(() => {
    if (name === 'dir') {
      setDriverinstructions(value)
    }
  }, [value])

  return <></>
}

export default OtherFieldManipulator
